import React from 'react'
import { toast, ToastContainer } from 'react-toastify'

const getToastPosition = (position) => {
  switch (position) {
    case 'tc':
      return toast.POSITION.TOP_CENTER
    case 'tl':
      return toast.POSITION.TOP_LEFT
    case 'tr':
      return toast.POSITION.TOP_RIGHT
    case 'bc':
      return toast.POSITION.BOTTOM_CENTER
    case 'bl':
      return toast.POSITION.BOTTOM_LEFT
    case 'br':
      return toast.POSITION.BOTTOM_RIGHT
    default:
      break
  }
}

/**
 * 
 * @param {string} type "warning | success | info | error"
 * @param {string} message 
 * @param {string} position "tc | tr | tl |  bc |  bl | br"
 * @param {object} aditionalParams  {
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        }
 * @returns 
 */
const newToast = (type, message, position = 'tr', aditionalParams = null) => {
  const toastPosition = getToastPosition(position)
  const defaultParams = {
    position: toastPosition,
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined
  }

  aditionalParams = { ...defaultParams, ...aditionalParams }

  switch (type) {
    case 'warning':
      return toast.warn(message, aditionalParams)
    case 'success':
      return toast.success(message, aditionalParams)
    case 'info':
      return toast.info(message, aditionalParams)
    case 'error':
      return toast.error(message, aditionalParams)
    default:
      break
  }
}

/**
 *
 * @param {boolean} enableMultiContainer
 * @param {string} containerId
 * @returns
 */
const newContainer = (containerId = '') => {
  return (
    <ToastContainer enableMultiContainer={true} containerId={containerId} />
  )
}

export { newToast, newContainer }
